import React from 'react';
import { Controller, Control } from 'react-hook-form';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import { ExternalMatchRequestRuleType } from 'generated/graphql';

import { RuleTypeChip } from '../components/RuleTypeChip';

interface RuleTypeFieldProps {
  control: Control<any>;
}

export const RuleTypeField: React.FC<RuleTypeFieldProps> = ({ control }) => {
  return (
    <FormControl>
      <FormLabel sx={{ marginTop: '10px', marginBottom: '10px' }}>Action Type</FormLabel>
      <Controller
        name="ruleType"
        control={control}
        defaultValue={ExternalMatchRequestRuleType.Approval}
        render={({ field }) => (
          <RadioGroup
            {...field}
            aria-labelledby="rule-type-label"
            sx={{ display: 'flex', gap: '10px' }}
          >
            <FormControlLabel
              value={ExternalMatchRequestRuleType.Approval}
              control={<Radio />}
              label={<RuleTypeChip active={true} type={ExternalMatchRequestRuleType.Approval} />}
            />
            <FormControlLabel
              value={ExternalMatchRequestRuleType.Rejection}
              control={<Radio />}
              label={<RuleTypeChip active={true} type={ExternalMatchRequestRuleType.Rejection} />}
            />
          </RadioGroup>
        )}
      />
    </FormControl>
  );
};
